import { IconProps } from "../../../types/style";

const NotifSVG2 = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20.19 14.06L19.06 12.18C18.81 11.77 18.59 10.98 18.59 10.5V8.62996C18.59 4.99996 15.64 2.04996 12.02 2.04996C8.38996 2.05996 5.43996 4.99996 5.43996 8.62996V10.49C5.43996 10.97 5.21996 11.76 4.97996 12.17L3.84996 14.05C3.41996 14.78 3.31996 15.61 3.58996 16.33C3.85996 17.06 4.46996 17.64 5.26996 17.9C6.34996 18.26 7.43996 18.52 8.54996 18.71C8.65996 18.73 8.76996 18.74 8.87996 18.76C9.01996 18.78 9.16996 18.8 9.31996 18.82C9.57996 18.86 9.83996 18.89 10.11 18.91C10.74 18.97 11.38 19 12.02 19C12.65 19 13.28 18.97 13.9 18.91C14.13 18.89 14.36 18.87 14.58 18.84C14.76 18.82 14.94 18.8 15.12 18.77C15.23 18.76 15.34 18.74 15.45 18.72C16.57 18.54 17.68 18.26 18.76 17.9C19.53 17.64 20.12 17.06 20.4 16.32C20.68 15.57 20.6 14.75 20.19 14.06ZM12.75 9.99996C12.75 10.42 12.41 10.76 11.99 10.76C11.57 10.76 11.23 10.42 11.23 9.99996V6.89996C11.23 6.47996 11.57 6.13996 11.99 6.13996C12.41 6.13996 12.75 6.47996 12.75 6.89996V9.99996Z'
          fill={color}
        />
        <path
          d='M14.8299 20.01C14.4099 21.17 13.2999 22 11.9999 22C11.2099 22 10.4299 21.68 9.87993 21.11C9.55993 20.81 9.31993 20.41 9.17993 20C9.30993 20.02 9.43993 20.03 9.57993 20.05C9.80993 20.08 10.0499 20.11 10.2899 20.13C10.8599 20.18 11.4399 20.21 12.0199 20.21C12.5899 20.21 13.1599 20.18 13.7199 20.13C13.9299 20.11 14.1399 20.1 14.3399 20.07C14.4999 20.05 14.6599 20.03 14.8299 20.01Z'
          fill={color}
        />
      </svg>
    </div>
  );
};

export default NotifSVG2;
